import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Surtidor } from '@shared/models/stock/Surtidor';
import { Tanque } from '@shared/models/stock/Tanque';

@Component({
  selector: 'app-visor-tanques-relacionados',
  templateUrl: './visor-tanques-relacionados.component.html',
  styleUrls: ['./visor-tanques-relacionados.component.css']
})
export class VisorTanquesRelacionadosComponent {

  @Input() listaDeTanques: Tanque[];
  @Input() surtidor: Surtidor;
  constructor(public activeModal: NgbActiveModal) { }

}
